import React from 'react';
import { Column, cls, Button } from '../../../packages/components';
import Device from '../../../devices/device';

function OptionButtonEvent(props) {
    const { title = '', onClick = null, active =false, iconClassName = null, image = null } = props;
    const device = Device.getDevice().getSubplatform();
    
    return (
        <Column>
            <Button className={cls(`focusable`, `event_option_button_section`, `event_option_button_section_${device || ''}`)} onClick={onClick}>
                {
                    iconClassName && <i className={cls('event_option_button_section_icon', iconClassName)}/>
                }
                {
                    image && <img src={image} className={cls('event_option_image_icon')}></img>
                }
                <span>
                    {title}
                </span>
                { active && 
                    <i className={cls('fa fa-check', 'event_option_check_icon')}/>
                }
            </Button>
        </Column>
    );
}

export default OptionButtonEvent;



// WEBPACK FOOTER //
// ./src/components/EventOptions/components/OptionButtonEvent.jsx